<template>
  <div class="content">
    <div class="flex gap-8">
      <div class="bg-gray-100 border border-gray-200 px-4 py-3 rounded-sm">
        <button-select
          v-model="tab"
          :options="tabs"
          size="sm"
          class="flex-col gap-2"
        />
      </div>

      <div class="flex-1">
        <component :is="tabComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
const ButtonSelect = () => import('@/components/global/ButtonSelect.vue');
const CandleLayerCache = () => import('@/components/developer/CandleLayerCache.vue');
const CandleTemplates = () => import('@/components/developer/CandleTemplates.vue');
const Dropdowns = () => import('@/components/developer/Dropdowns.vue');
const Images = () => import('@/components/developer/Images.vue');
const LabelPrinters = () => import('@/components/developer/LabelPrinters.vue');
const Roles = () => import('@/components/developer/Roles.vue');

export default {
  name: 'Developer',
  components: {
    ButtonSelect,
    CandleLayerCache,
    CandleTemplates,
    Dropdowns,
    Images,
    LabelPrinters,
    Roles,
  },
  computed: {
    tabComponent() {
      return this.tabs[this.tab].component;
    },
  },
  data() {
    return {
      tab: 0,
      tabs: [
        { text: 'Candle Layer Cache', value: 0, component: CandleLayerCache },
        { text: 'Candle Templates', value: 1, component: CandleTemplates },
        { text: 'Dropdown', value: 2, component: Dropdowns },
        { text: 'Images', value: 3, component: Images },
        { text: 'Label Printers', value: 4, component: LabelPrinters },
        { text: 'Roles', value: 5, component: Roles },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
